export default {
  List: require('./List').default,
  Detail: require('./Detail').default,
  ListDiscussion: require('./ListDiscussion.vue').default,
}